/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DOCUMENT, Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdnModalLoadingService {
  private readonly loadingClass = 'modalLoading';
  private timeoutPromise: any;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document) {
  }

  applyModalLoading(): void {
    this.getBody()?.classList.add(this.loadingClass);
    this.timeoutPromise = setTimeout(() => this.removeModalLoading(), 30000);
  }

  removeModalLoading(): void {
    this.getBody()?.classList.remove(this.loadingClass);
    if (this.timeoutPromise) {
      clearTimeout(this.timeoutPromise);
      this.timeoutPromise = null;
    }
  }

  private getBody(): HTMLElement | null {
    return this.document.body;
  }
}
